import {TweenMax, Linear} from 'gsap';

class ThumbnailsCarousel {

    protected $template: JQuery;
    private $closeBtn: JQuery;
    private $prevBtn: JQuery;
    private $nextBtn: JQuery;
    private $carousel: JQuery;
    private $controls: JQuery;
    private $thumbnails: JQuery;

    constructor(template: JQuery, carousel: JQuery, controls: JQuery, thumbnails: JQuery) {

        this.$template = template;
        this.$carousel = carousel;
        this.$controls = controls;
        this.$thumbnails = thumbnails;
        this.init();
    }


    private init(): void {

        this.$closeBtn = this.$template.find(".closeBtn");
        this.$closeBtn.on("click tap", (event: JQuery.Event) => {
            event.preventDefault();
            this.transitionOut();
        });

        this.createCarousel();
        this.createControls();
        this.createThumbnails();
        this.changeCarouselStatus(0);
    }

    private createCarousel(): void {
        this.$carousel.owlCarousel({
            items: 1,
            margin: 15,
            loop: false,
            touchDrag: true,
            mouseDrag: true,
            nav: false,
            dots: false,
            stagePadding: 8,
            smartSpeed: 500
        });
        this.$carousel.on('changed.owl.carousel', (event: JQuery.Event) => {
            let timer: any = setTimeout(() => {
                let target: JQuery = this.$carousel.find(".owl-item.active");
                this.changeCarouselStatus(target.index());
                window.clearTimeout(timer);
                timer = null;
            }, 300)
        });
    }


    private changeCarouselStatus(id: number): void {

        let thumbnailTotal: number = this.$thumbnails.find(".owl-item").length;
        for (let i: number = 0; i < thumbnailTotal; i++) {
            let thumbnail: JQuery = this.$thumbnails.find(".owl-item:eq(" + i + ")");
            thumbnail.removeClass("current");
            if (i == id) {
                thumbnail.addClass("current");
            } else {
                thumbnail.removeClass("current");
            }
        }
    }

    private createThumbnails(): void {
        let navTotal: number = this.$thumbnails.find(".carousel-item").length;
        for (let i: number = 0; i < navTotal; i++) {
            let item: JQuery = this.$thumbnails.find(".carousel-item:eq(" + i + ")");
            item.attr("data-id", i);
        }
        this.$thumbnails.owlCarousel({
            items: 3,
            loop: false,
            center: false,
            autoWidth: true,
            nav: false,
            dots: false,
            smartSpeed: 200
        });
        this.$thumbnails.on('click tap', '.carousel-item', (event) => {
            event.preventDefault();
            let itemId: number = $(event.currentTarget).data("id");
            this.$thumbnails.trigger('to.owl.carousel', itemId);
            this.$carousel.trigger('to.owl.carousel', itemId);
            this.changeCarouselStatus(itemId);
        });
    }

    private createControls(): void {
        this.$prevBtn = this.$controls.find(".carousel-control-prev");
        this.$nextBtn = this.$controls.find(".carousel-control-next");
        this.$prevBtn.on("click tap", (eventObject: JQueryEventObject) => {
            eventObject.preventDefault();
            this.$carousel.trigger('prev.owl.carousel', [500]);
        });
        this.$nextBtn.on("click tap", eventObject => {
            eventObject.preventDefault();
            this.$carousel.trigger('next.owl.carousel', [500]);
        });
    }

    public transitionIn(): void {

        this.$template.css("display", "block");
        TweenMax.to(this.$template, 0.3, {
            alpha: 1,
            ease: Linear.easeOut
        });
    }

    public transitionOut(): void {
        TweenMax.to(this.$template, 0.3, {
            alpha: 0,
            ease: Linear.easeOut,
            onComplete: () => {
                this.$template.css("display", "none");
            }
        });
    }
}

export = ThumbnailsCarousel;